
import {Box} from '@mui/material'
import { useEffect, useRef } from 'react';

const defaultImg = '/imgs/default.png'

const MuiImage = ({ src, alt, defaultSrc = defaultImg, boxSX = {'>img': {width: '100%', height: '100%'}}, boxProps = {}, imageProps = {} } = props) => {
    const ref = useRef()
    const loaded = event => {
        if (!event.target.src.includes(defaultSrc)) {
            event.target.src = defaultSrc
        }
    }
    useEffect(() => {
        if (!ref?.current?.src?.includes(src)) {
            ref.current.src = src
        }
        ref?.current?.addEventListener('error', loaded)
        return () => ref?.current?.removeEventListener('error', loaded)
    }, [])

    return <Box width="100%" height="100%" sx={boxSX} {...boxProps} position="relative">
        <img ref={ref} alt={alt} {...imageProps}/>
    </Box>
}

export default MuiImage